export const INVOICE_DISCOUNT_LABELS = {
  DEALER_FEE: 'Transactiekosten',
  DEALER_FEE_AMOUNT: 'Transactiekosten',
  DEALER_SMS_COST: 'SMS kosten',
  DEALER_TECRMI_COST: 'Gebruikskosten TecRMI',
  DEALER_SERVICE_PERCENTAGE: 'Administratiekosten',
  DEALER_EXPENSE_PERCENTAGE: 'Bijdrage coulance-/garantiefonds',
  SLA_APPROVED_INVOICE_DISCOUNT: 'Werkzaamheden',
  SLA_APPROVED_INVOICE_NEW_TIRES_DISCOUNT: 'Banden',
};

export const INVOICE_DISCOUNT_ORDER = [
  'SLA_INVOICE_DISCOUNT',
  'SLA_INVOICE_NEW_TIRES_DISCOUNT',
  'DEALER_SERVICE_PERCENTAGE',
  'DEALER_EXPENSE_PERCENTAGE',
  'DEALER_FEE',
  'DEALER_FEE_AMOUNT',
  'DEALER_TECRMI_COST',
  'DEALER_SMS_COST',
  'SLA_APPROVED_INVOICE_DISCOUNT',
  'SLA_APPROVED_INVOICE_NEW_TIRES_DISCOUNT',
];

export const INVOICE_COMPONENTS_HEADER_HEIGHT_IN_PX = 64;
export const INVOICE_COMPONENTS_FOOTER_HEIGHT_IN_PX = 51;
